export default "__VITE_PUBLIC_ASSET__b8d9a860__"